import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

const swiper = new Swiper('.js-swiper', {
  spaceBetween: 30,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    prevEl: ".swiper-button-prev",
  },
})